import { List } from 'immutable';

import State from '../core/State';
import Country from '../entity/Country';

export const setCountries = (countries: List<Country>) => (state: State): State => ({
  ...state,
  countries,
});
